import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    root: {
      backgroundColor: "#fff",
      borderRadius: 3,
      boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.1)",
      display: "flex",
      flexDirection: "column",
      flex: "auto"
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: 80,
      fontSize: 16,
      padding: 16,
      [theme.breakpoints.down("sm")]: {
        padding: "0 0 10px 0",
        height: "auto",
        fontSize: 12
      }
    },
    mobileHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: 46,
      color: primary.dark,
      marginTop: -10
    },
    mobileTitle: {
      fontSize: 16,
      color: "#595a5a"
    },
    mobileExamHistoryItem: {
      "&:first-child": {
        marginBottom: 0
      }
    },
    comment: {
      borderLeft: "none",
      borderRight: "none",
      "& div": {
        fontSize: 14
      },
      "& > div": {
        padding: "11px 20px 11px 16px"
      }
    },
    body: {
      flexGrow: 1,
      minHeight: 640
    },
    noItems: {
      height: 580,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textTransform: "capitalize",
      color: primary.light,
      [theme.breakpoints.down("sm")]: {
        height: 100,
        backgroundColor: "#fff"
      }
    },
    filterWrapper: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      fontSize: 14,
      color: "#1a1a1a",
      [theme.breakpoints.down("sm")]: {
        fontSize: 12
      }
    },
    filterSelect: {
      lineHeight: "normal",
      "&:before, &:after": {
        display: "none"
      },
      "& .MuiSelect-select": {
        paddingBottom: 6,
        color: theme.palette.secondary.dark,
        "&:focus": {
          backgroundColor: "transparent"
        },
        [theme.breakpoints.down("sm")]: {
          fontSize: 12,
          paddingBottom: 5
        }
      },
      "& .MuiSelect-icon": {
        fill: theme.palette.secondary.dark
      },
      "& .MuiSelect-select:focus": {
        backgroundColor: "transparent"
      }
    },
    itemButton: {
      padding: 0,
      textTransform: "none",
      textAlign: "unset",
      width: "100%",
      display: "inline"
    },
    item: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: 80,
      boxSizing: "border-box",
      borderTop: "1px solid #eeeeee",
      padding: "16px 28px 16px 16px",
      "&:nth-child(even)": {
        backgroundColor: "#fbfbfb"
      },
      "&:last-child": {
        borderBottom: "1px solid #eeeeee"
      }
    },
    itemData: {
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      gap: 4
    },
    itemName: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      flex: "auto",
      width: "100%",
      fontSize: 12,
      margin: 0,
      minHeight: 19
    },
    itemDates: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      minWidth: 112,
      fontSize: 12
    },
    itemStatus: {
      fontSize: 12,
      color: theme.palette.text.secondary
    },
    itemStatusActive: {
      color: theme.palette.secondary.dark
    },
    itemStatusExpiring: {
      color: "#f59a23"
    },
    itemStatusExpired: {
      color: "#ff001f"
    },
    launchIcon: {
      fontSize: 22,
      color: theme.palette.text.primary
    },
    pagination: {
      height: 62
    },
    filler: {
      width: "100%",
      flexGrow: 1,
      padding: 16,
      "& $noItems": {}
    }
  };
});
